import React from "react";
import { SafeAreaView } from "react-native";
import styled from "styled-components/native";
import { light_black } from "../../StyleHelpers";
import ImgProgressBar from "./ImgProgressBar";
import TopAppbar from "../../components/TopAppBar";
import useGenericContentStore from "../../store/genericContent.store";
import NarrowScreenContainer from "../Layout/NarrowScreenContainer";

const StyledTextField = styled.View`
	height: 90px;
	border-radius: 16px;
	overflow: hidden;
	margin-bottom: 24px;
	margin-top: 10px;
`;

const StyledWrapper = styled.View`
	z-index: -1;
	margin: 15vh 14.1% 70px 14.1%;
`;

const ButtonContainer = styled.View`
	height: 72px;
	overflow: hidden;
	border-radius: 16px;
	margin-left: 10px;
	margin-right: 10px;
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 100%;
`;

const StyledButtonContainer = styled.View`
	flex-direction: row;
	width: 71.8%;
	position: absolute;
	bottom: 15%;
	margin: 0 14.1% 0 14.1%;
`;

const StyledFormContainer = styled.View`
	margin-top: 82px;
	flex-direction: column;
`;

const StyledPrivacyContainer = styled.View`
	margin-top: 80px;
	left: 15%;
	height: 42px;
	width: 13%;
	position: fixed;
	overflow: hidden;
`;
/*Narrow*/
const StyledNarrowButtonContainer = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
`;

const StyledNarrowButtonWrapper = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
`;

const StyledNarrowButton = styled.View`
	display: flex;
	height: 3.5rem;
	min-height: 3.5rem;
	padding: 0 1rem;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 0.625rem;
	align-self: stretch;
`;

const StyledNarrowPrivacyButton = styled.View`
	display: flex;
	height: 2rem;
	padding: 0 1rem;
	flex-direction: column;
	gap: 0.625rem;
	align-self: stretch;
`;

const StyledNarrowContent = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	flex: 1 0 0;
`;

const StyledNarrowTextField = styled.View`
	display: flex;
	height: 3.5rem;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
	align-self: stretch;
`;

const SignInLoader = () => {
	const isNarrow = useGenericContentStore((state: any) => state.isNarrow);

	const renderSignInLoader = () => {
		return (
			<>
				{/* @ts-ignore */}
				<StyledWrapper>
					{/* @ts-ignore */}
					<StyledFormContainer>
						{/* @ts-ignore */}
						<StyledTextField>
							<ImgProgressBar />
						</StyledTextField>
						{/* @ts-ignore */}
						<StyledTextField>
							<ImgProgressBar />
						</StyledTextField>
					</StyledFormContainer>
				</StyledWrapper>
				{/* @ts-ignore */}
				<StyledButtonContainer>
					{/* @ts-ignore */}
					<ButtonContainer>
						<ImgProgressBar />
					</ButtonContainer>
					{/* @ts-ignore */}
					<ButtonContainer>
						<ImgProgressBar />
					</ButtonContainer>
					{/* @ts-ignore */}
					<StyledPrivacyContainer>
						<ImgProgressBar isNoBorder />
					</StyledPrivacyContainer>
				</StyledButtonContainer>
			</>
		);
	};

	const renderNarrowSignInLoader = () => {
		return (
			<NarrowScreenContainer>
				{/* @ts-ignore */}
				<StyledNarrowButtonContainer>
					{/* @ts-ignore */}
					<StyledNarrowButtonWrapper>
						{/* @ts-ignore */}
						<StyledNarrowButton>
							<ImgProgressBar />
						</StyledNarrowButton>
						{/* @ts-ignore */}
						<StyledNarrowButton>
							<ImgProgressBar />
						</StyledNarrowButton>
					</StyledNarrowButtonWrapper>
					{/* @ts-ignore */}
					<StyledNarrowPrivacyButton>
						<ImgProgressBar isNoBorder />
					</StyledNarrowPrivacyButton>
				</StyledNarrowButtonContainer>
				{/* @ts-ignore */}
				<StyledNarrowContent>
					{/* @ts-ignore */}
					<StyledNarrowTextField>
						<ImgProgressBar />
					</StyledNarrowTextField>
					{/* @ts-ignore */}
					<StyledNarrowTextField>
						<ImgProgressBar />
					</StyledNarrowTextField>
				</StyledNarrowContent>
			</NarrowScreenContainer>
		);
	};

	return (
		<SafeAreaView style={{ flex: 1, backgroundColor: light_black }}>
			<TopAppbar isNarrow={isNarrow} />
			{isNarrow ? renderNarrowSignInLoader() : renderSignInLoader()}
		</SafeAreaView>
	);
};

export default SignInLoader;
